// ----------------------------------------------------------------------------
// Section: Featured Tiles
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { A11y, Keyboard, Scrollbar } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/scrollbar';
import './_featured-tiles.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const FEATURED_TILES_SLIDER_SELECTOR = '.carousel--featured-tiles-container';
const CAROUSEL_SELECTOR              = '.carousel--featured-tiles';

// -------------------------------------
// Helpers
// -------------------------------------

const initFeaturedTiles = (slider) => {
    const carousel = slider.querySelector(CAROUSEL_SELECTOR);
    const scrollbar = slider.querySelector('.swiper-scrollbar');

    if (!carousel) {
        return;
    }

    // Check if swiper is already initialized
    if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
    }

    const swiper = new Swiper(carousel, {
        modules: [A11y, Keyboard, Scrollbar],
        slidesPerView: 1.1,
        spaceBetween: 5,
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true,
        grabCursor: true,
        scrollbar: {
            el: scrollbar,
            draggable: true,
        },
        breakpoints: {
            680: {
                slidesPerView: 3,
                spaceBetween: 5,
            }
        }
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');

        slideLink.addEventListener('focus', function() {
            swiper.slideTo(index);
        });

        // Prevent swiper drag on CTA areas
        const ctaContainer = slide.querySelector('.featured-tile__external-ctas');
        if (ctaContainer) {
            ctaContainer.addEventListener('touchstart', function(e) {
                e.stopPropagation();
            });
            ctaContainer.addEventListener('mousedown', function(e) {
                e.stopPropagation();
            });
        }
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const featuredTilesSliders = document.querySelectorAll(FEATURED_TILES_SLIDER_SELECTOR);


    featuredTilesSliders.forEach((featuredTilesSlider) => {

        initFeaturedTiles(featuredTilesSlider);
    });
});
